import React from 'react';
import { TableToggleRowsSelectedProps } from 'react-table';

import TableCheckbox from 'views/MTable/TableCheckbox/TableCheckbox';

type Props = TableToggleRowsSelectedProps & {
  className?: string;
  disableSelection?: boolean;
  toggleRowsSelectedProps: TableToggleRowsSelectedProps;
  rowCheckbox?: boolean;
  onToggle?: () => void;
};

const MTableCellExpandCheckView: React.FC<Props> = (props: React.PropsWithChildren<Props>) => {
  return (
    <TableCheckbox
      className={props.className}
      {...props.toggleRowsSelectedProps}
      onToggle={props.onToggle}
      disabled={props.disableSelection}
      rowCheckbox={props.rowCheckbox}
    ></TableCheckbox>
  );
};

MTableCellExpandCheckView.displayName = 'MTableCellExpandCheckView';
MTableCellExpandCheckView.defaultProps = {};

export default MTableCellExpandCheckView;
